import React, { Component } from 'react';
import { Popup } from 'devextreme-react';

import ViewTodo from './View';

import * as fn from '../../../../utilities/_functions';

import './_index.scss';

const TODO_POPUP_ID = '__todo-popup';

export default class TodoModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            display: false,
            zIndex: null,
            item: null,
        };
        this.handleClose = this.handleClose.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
    }

    componentWillUnmount() {
        if (this.props.onClose) { this.props.onClose(); }
    }

    show = (item) => {
        if (item) {
            const zIndex = fn.getHighestZIndex() + 1;
            this.setState({ display: true, zIndex: zIndex, item: item });
        }
    }

    handleShowing = event => {
        const popup = document.getElementById(TODO_POPUP_ID);
        if (popup) {
            // const { zIndex } = this.state;
            // popup.style.zIndex = zIndex;
        }
    }

    handleClose = event => {
        const popup = document.getElementById(TODO_POPUP_ID);
        const { defaultMode } = this.state;

        if (popup) {
            // popup.style.zIndex = null;
        }

        this.setState({ mode: defaultMode, display: false, zIndex: null, item: null });
    }

    handleSuccess = (event, result) => {
        if (fn.isFunction(this.props.onSuccess)) {
            this.props.onSuccess(event, result);
        }
    }

    renderTitle = () => {
        return <div className='popup-title-draggable'></div>
    }

    renderContent = () => {
        const { item } = this.state;

        if (!item) return null;

        const contentProps = {
            item: item,
            onSuccess: this.handleSuccess,
            onClose: this.handleClose,
        };

        return <ViewTodo {...contentProps} />;
    }

    render() {
        return <>{
            <Popup
                wrapperAttr={{ id: TODO_POPUP_ID, class: 'dx-popup-todo' }}
                animation={{
                    show: {
                        type: 'pop',
                        duration: 200,
                        from: { opacity: 0, scale: 0 },
                        to: { opacity: 1, scale: 1 }
                    },
                    hide: {
                        type: 'pop',
                        duration: 200,
                        from: { opacity: 1, scale: 1 },
                        to: { opacity: 0, scale: 0 }
                    }
                }}
                visible={this.state.display}
                shading={true}
                shadingColor="rgba(0, 0, 0, 0.2)"
                width={960}
                maxHeight={'500px'}
                dragEnabled={true}
                dragOutsideBoundary={true}
                showTitle={true}
                titleRender={this.renderTitle}
                contentRender={this.renderContent}
                onShowing={this.handleShowing}
                onShown={this.handleShowing}
                onHiding={this.handleClose}
            />
        }</>
    }
}